var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanSpecialtyHealthLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234,
    height: 31,
    viewBox: "0 0 234 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.8876L21.3383 27.0034H21.3957L0 17.5678V21.8876Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6211L21.382 27.0034H21.3957V27.0025L0 5.64914V10.6211Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.6697L21.371 26.5068H21.3957L0 12.1051V16.6697Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4442 0.186428L21.3957 27.0034V26.9363L15.7973 0.186428H11.4442Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.186428V3.5307L21.3957 27.0034V26.9868L3.35463 0.186428H0Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26.5068H20.8981L0 23.0305V26.5068Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4151 0.186428L21.3957 27.0034L21.3957 0.186428H17.4151Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47817 0.186428L21.3957 27.0034V26.9734L9.53308 0.186428H4.47817Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8854 2.04489H30.8134L28.9998 17.4952H32.6981L30.8854 2.04489ZM32.952 19.5746H28.7473L27.7684 27.0034H25.3763L29.2169 0.186428H32.4811L36.323 27.0034H33.9304L32.952 19.5746Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.39 6.65112H39.5508V7.9964H39.6254C40.3352 6.97796 41.0811 6.43352 42.3099 6.43352C43.1678 6.43352 43.9878 6.86871 44.4735 7.66956C45.106 6.90618 45.8528 6.43352 46.8589 6.43352C48.76 6.43352 49.618 7.81357 49.618 9.41211V26.4611H47.3062V10.1764C47.3062 9.08527 47.0075 8.46905 46.15 8.46905C45.218 8.46905 44.6596 9.30466 44.6596 10.2856V26.4611H42.3478V10.1764C42.3478 9.08527 42.0492 8.46905 41.1926 8.46905C40.2611 8.46905 39.7013 9.30466 39.7013 10.2856V26.4611H37.39V6.65112Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0295 10.2492C57.0295 8.79553 56.4327 8.2511 55.5011 8.2511C54.5686 8.2511 53.9728 8.79553 53.9728 10.2492V15.0841H57.0295V10.2492ZM57.0295 20.0639H59.3413V22.8623C59.3413 25.8797 57.4772 26.6792 55.5011 26.6792C53.525 26.6792 51.6619 25.8797 51.6619 22.8623V10.2492C51.6619 7.23175 53.525 6.43361 55.5011 6.43361C57.4772 6.43361 59.3413 7.23175 59.3413 10.2492V17.1191H53.9728V22.8623C53.9728 24.3169 54.5686 24.8617 55.5011 24.8617C56.4327 24.8617 57.0295 24.3169 57.0295 22.8623V20.0639Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2755 6.65112H63.4377V8.03251H63.5118C64.2193 6.97796 65.1513 6.43352 66.6056 6.43352V8.68619C64.3683 8.68619 63.5859 9.52226 63.5859 11.5939V26.4611H61.2755V6.65112Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6514 2.9808H70.1118V0.215742H67.6514V2.9808ZM67.725 26.461H70.0378V6.65098H67.725V26.461Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8956 9.88548C76.8956 8.649 76.559 8.25083 75.8144 8.25083C75.032 8.25083 74.5472 8.7596 74.5472 9.88548V23.3713C74.5472 24.3884 74.8449 24.8619 75.7024 24.8619C76.5589 24.8619 76.8956 24.2809 76.8956 23.3713V20.1719H79.2069V23.3343C79.2069 25.4799 77.9762 26.6789 75.7394 26.6789C73.8758 26.6789 72.2349 25.7711 72.2349 23.6972V10.2493C72.2349 7.23194 74.0981 6.43379 76.0756 6.43379C78.0901 6.43379 79.2069 7.4879 79.2069 9.63087V12.9399H76.8956V9.88548Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5065 16.0284C85.3148 16.0284 83.4502 16.5006 83.4502 18.1731V22.6807C83.4502 24.0987 83.6739 24.8616 84.9045 24.8616C85.9111 24.8616 86.5065 24.1339 86.5065 22.8266V16.0284ZM86.5065 9.92223C86.5065 8.72186 86.0972 8.25101 85.1643 8.25101C83.86 8.25101 83.6739 9.01484 83.6739 10.1764V12.03H81.3621V9.70419C81.3621 7.66956 83.115 6.43352 85.2393 6.43352C87.477 6.43352 88.8183 7.34181 88.8183 9.88566V26.4611H86.657V25.4065H86.582C85.9477 26.1699 85.2777 26.6791 83.897 26.6791C82.107 26.6791 81.138 25.4065 81.138 23.4071V18.0296C81.138 15.5571 82.8539 14.2118 86.5065 14.2118V9.92223Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7516 6.65112H92.9138V7.9964H92.9888C93.5102 7.15943 94.4792 6.43352 95.6724 6.43352C97.5735 6.43352 98.4315 7.81357 98.4315 9.41211V26.4611H96.1188V10.2856C96.1188 9.23198 95.7104 8.46905 94.6663 8.46905C93.5843 8.46905 93.0643 9.48524 93.0643 10.2856V26.4611H90.7516V6.65112Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.988 3.81464C108.988 2.79801 108.727 2.03463 107.57 2.03463C106.414 2.03463 106.154 2.79801 106.154 3.81464V6.57834C106.154 7.41441 106.302 8.25092 106.714 8.94071L110.628 15.4834C111.186 16.3917 111.523 17.5207 111.523 18.6818V22.8265C111.523 25.2972 110.031 26.679 107.57 26.679C104.85 26.679 103.544 25.48 103.544 22.8265V19.2267H106.005V22.6811C106.005 23.9176 106.488 24.644 107.57 24.644C108.576 24.644 109.063 23.9176 109.063 22.6811V19.0096C109.063 18.1013 108.875 17.4101 108.355 16.5005L104.738 10.3596C104.066 9.23189 103.693 8.35791 103.693 7.01398V3.85076C103.693 1.27125 105.073 0 107.57 0C110.329 0 111.447 1.27125 111.447 3.67019V7.01398H108.988V3.81464Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.674 10.3596C118.674 8.97728 118.266 8.25092 117.332 8.25092C116.4 8.25092 115.618 8.83192 115.618 10.4309V22.4635C115.618 23.6968 116.289 24.644 117.295 24.644C118.228 24.644 118.674 23.8084 118.674 22.3534V10.3596ZM113.307 6.65103H115.469V7.88571H115.544C115.915 6.97787 116.7 6.43343 118.004 6.43343C119.494 6.43343 120.988 7.30516 120.988 10.2855V23.5912C120.988 25.3699 119.943 26.679 118.341 26.679C117.147 26.679 116.178 26.1342 115.692 25.2245H115.618V30.3876H113.307V6.65103Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.288 10.2492C128.288 8.79553 127.692 8.2511 126.76 8.2511C125.827 8.2511 125.231 8.79553 125.231 10.2492V15.0841H128.288V10.2492ZM128.288 20.0639H130.602V22.8623C130.602 25.8797 128.735 26.6792 126.76 26.6792C124.783 26.6792 122.92 25.8797 122.92 22.8623V10.2492C122.92 7.23175 124.783 6.43361 126.76 6.43361C128.735 6.43361 130.602 7.23175 130.602 10.2492V17.1191H125.231V22.8623C125.231 24.3169 125.827 24.8617 126.76 24.8617C127.692 24.8617 128.288 24.3169 128.288 22.8623V20.0639Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.195 9.88548C137.195 8.649 136.857 8.25083 136.113 8.25083C135.331 8.25083 134.845 8.7596 134.845 9.88548V23.3713C134.845 24.3884 135.143 24.8619 136 24.8619C136.857 24.8619 137.195 24.2809 137.195 23.3713V20.1719H139.505V23.3343C139.505 25.4799 138.275 26.6789 136.039 26.6789C134.174 26.6789 132.533 25.7711 132.533 23.6972V10.2493C132.533 7.23194 134.396 6.43379 136.374 6.43379C138.385 6.43379 139.505 7.4879 139.505 9.63087V12.9399H137.195V9.88548Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.623 2.9808H144.083V0.215742H141.623V2.9808ZM141.698 26.461H144.01V6.65098H141.698V26.461Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.574 16.0284C150.381 16.0284 148.517 16.5006 148.517 18.1731V22.6807C148.517 24.0987 148.741 24.8616 149.971 24.8616C150.978 24.8616 151.574 24.1339 151.574 22.8266V16.0284ZM151.574 9.92223C151.574 8.72186 151.165 8.25101 150.233 8.25101C148.928 8.25101 148.741 9.01484 148.741 10.1764V12.03H146.431V9.70419C146.431 7.66956 148.181 6.43352 150.307 6.43352C152.543 6.43352 153.887 7.34181 153.887 9.88566V26.4611H151.724V25.4065H151.648C151.016 26.1699 150.344 26.6791 148.965 26.6791C147.175 26.6791 146.207 25.4065 146.207 23.4071V18.0296C146.207 15.5571 147.92 14.2118 151.574 14.2118V9.92223Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.081 26.461H158.391V0.215742H156.081V26.461Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.963 3.99716L163.276 3.12453V6.65116H164.913V8.4691H163.276V23.5169C163.276 24.4256 163.759 24.6441 164.43 24.6441H164.913V26.4611H163.796C161.858 26.4611 160.963 25.5515 160.963 24.0256V8.4691H159.807V6.65116H160.963V3.99716Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.837 30.3875H167.524L168.344 26.4614L165.401 6.65094H167.711L169.351 19.9909H169.427L171.402 6.65094H173.714L169.837 30.3875Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.389 0.215922H186.85V26.4611H184.389V13.8475H180.698V26.4611H178.238V0.215922H180.698V11.8124H184.389V0.215922Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.708 10.2492C194.708 8.79553 194.112 8.2511 193.18 8.2511C192.249 8.2511 191.653 8.79553 191.653 10.2492V15.0841H194.708V10.2492ZM194.708 20.0639H197.021V22.8623C197.021 25.8797 195.157 26.6792 193.18 26.6792C191.205 26.6792 189.341 25.8797 189.341 22.8623V10.2492C189.341 7.23175 191.205 6.43361 193.18 6.43361C195.157 6.43361 197.021 7.23175 197.021 10.2492V17.1191H191.653V22.8623C191.653 24.3169 192.249 24.8617 193.18 24.8617C194.112 24.8617 194.708 24.3169 194.708 22.8623V20.0639Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.321 16.0284C203.128 16.0284 201.266 16.5006 201.266 18.1731V22.6807C201.266 24.0987 201.489 24.8616 202.719 24.8616C203.727 24.8616 204.321 24.1339 204.321 22.8266V16.0284ZM204.321 9.92223C204.321 8.72186 203.911 8.25101 202.98 8.25101C201.673 8.25101 201.489 9.01484 201.489 10.1764V12.03H199.177V9.70419C199.177 7.66956 200.929 6.43352 203.054 6.43352C205.29 6.43352 206.634 7.34181 206.634 9.88566V26.4611H204.472V25.4065H204.395C203.762 26.1699 203.091 26.6791 201.713 26.6791C199.921 26.6791 198.951 25.4065 198.951 23.4071V18.0296C198.951 15.5571 200.668 14.2118 204.321 14.2118V9.92223Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.826 26.461H211.139V0.215742H208.826V26.461Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.711 3.99716L216.02 3.12453V6.65116H217.663V8.4691H216.02V23.5169C216.02 24.4256 216.504 24.6441 217.177 24.6441H217.663V26.4611H216.543C214.603 26.4611 213.711 25.5515 213.711 24.0256V8.4691H212.555V6.65116H213.711V3.99716Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.816 0.215922H221.129V7.99644H221.203C221.649 7.15948 222.621 6.43357 223.812 6.43357C225.638 6.43357 226.497 7.81361 226.497 9.41215V26.4611H224.187V10.2857C224.187 9.23203 223.777 8.4691 222.732 8.4691C221.649 8.4691 221.129 9.48528 221.129 10.2857V26.4611H218.816V0.215922Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.457 24.0334H230.773C231.133 24.0334 231.437 23.9066 231.437 23.577C231.437 23.3427 231.263 23.1089 230.773 23.1089C230.631 23.1089 230.533 23.1202 230.457 23.131V24.0334ZM230.457 25.5105H230.021V22.8439C230.249 22.8118 230.468 22.7798 230.795 22.7798C231.209 22.7798 231.481 22.8651 231.644 22.9816C231.808 23.0994 231.895 23.2795 231.895 23.5346C231.895 23.8845 231.655 24.0975 231.361 24.1824V24.2041C231.602 24.2461 231.764 24.4587 231.818 24.8519C231.884 25.2659 231.95 25.4257 231.993 25.5105H231.535C231.47 25.4257 231.404 25.1814 231.351 24.8307C231.285 24.4907 231.11 24.3625 230.762 24.3625H230.457V25.5105ZM230.915 22.1004C229.835 22.1004 228.953 23.0037 228.953 24.1183C228.953 25.2555 229.835 26.148 230.925 26.148C232.015 26.1588 232.887 25.2555 232.887 24.1296C232.887 23.0037 232.015 22.1004 230.925 22.1004H230.915ZM230.925 21.7284C232.266 21.7284 233.333 22.7902 233.333 24.1183C233.333 25.4681 232.266 26.52 230.915 26.52C229.575 26.52 228.484 25.4681 228.484 24.1183C228.484 22.7902 229.575 21.7284 230.915 21.7284H230.925Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanSpecialtyHealthLogoDark);
export default __webpack_public_path__ + "static/media/American_Specialty_Health_Logo_Dark.a5a680b96a64cc97408722997af1a003.svg";
export { ForwardRef as ReactComponent };